export enum MapType {
  STRAFE = 'STRAFE',
  WEAPON = 'WEAPON',
  EXTRA = 'EXTRA',
}
